import {createContext} from 'react';
const TitleContext = createContext({
    title: 'Dashboard'
})
export default TitleContext
